import React from 'react';
import styles from './RejectButton.module.css';


export default function RejectButton({ handleReject }) {

    return (
      <div className={styles.buttonContainer}>
          <button type="submit" className={styles.rejectButton} onClick={handleReject}> REJECT </button>
      </div>
    );

};
